// src/views/about.ts
import { html, type TemplateResult } from 'lit-html';

export function renderAbout(): TemplateResult {
  return html`
    <div class="container">
      <h2>关于本测试</h2>

      <section class="result-section">
        <h3>VARK 是什么</h3>
        <p>VARK 模型由 Neil Fleming 在 1987 年提出,描述人在吸收信息时倾向的四种感知通道:</p>
        <ul>
          <li><strong>V (Visual)</strong> 视觉:图形、图表、空间布局</li>
          <li><strong>A (Aural)</strong> 听觉:讲座、讨论、口头解释</li>
          <li><strong>R (Read/Write)</strong> 读写:文字阅读与书面表达</li>
          <li><strong>K (Kinesthetic)</strong> 动觉:实践、操作、真实经验</li>
        </ul>
        <p>VARK 描述的是<strong>偏好</strong>而非能力。一个 V 偏好者并非"听不进话",只是"看比听更高效"。</p>
      </section>

      <section class="result-section">
        <h3>本网站的方法学</h3>
        <ul>
          <li><strong>题库 A</strong>:VARK 官方问卷 v8 (16 题),来源 vark-learn.com,经本项目中译并保留英文原文</li>
          <li><strong>题库 B</strong>:基于 VARK 四维度模型自研的 16 题中文题库,情景以本土化场景为主、与官方题尽量差异化</li>
          <li><strong>计分</strong>:严格遵循 Fleming 官方阶梯计分法 (stepping rule)。先求各维度得分,再由总分查表得到 step value,最后将与最高分差不超过 step 的所有维度纳入"偏好维度"</li>
          <li><strong>类型代码</strong>:偏好维度按 V→A→R→K 顺序拼接,共 16 种 (V/A/R/K/VA/VR/VK/AR/AK/RK/VAR/VAK/VRK/ARK/VARK)</li>
        </ul>
      </section>

      <section class="result-section">
        <h3>信效度参考</h3>
        <p>对 VARK 量表心理测量学性质最系统的研究:</p>
        <blockquote>
          Leite, W. L., Svinicki, M., &amp; Shi, Y. (2010). Attempted validation of the scores of the VARK: Learning styles inventory with multitrait–multimethod confirmatory factor analysis models. <em>Educational and Psychological Measurement</em>, 70(2), 323-339.
          <br><a href="https://doi.org/10.1177/0013164409344507" target="_blank" rel="noopener">DOI: 10.1177/0013164409344507</a>
        </blockquote>
        <p>该研究发现 VARK 各维度内部一致性 α 在 0.77 ~ 0.85 之间,符合心理量表可接受范围。</p>
      </section>

      <section class="result-section">
        <h3>⚠ 重要的局限性</h3>
        <p>"学习风格"概念在教育心理学界至今仍存争议。最具影响力的批评综述之一:</p>
        <blockquote>
          Pashler, H., McDaniel, M., Rohrer, D., &amp; Bjork, R. (2008). Learning styles: Concepts and evidence. <em>Psychological Science in the Public Interest</em>, 9(3), 105-119.
          <br><a href="https://doi.org/10.1111/j.1539-6053.2009.01038.x" target="_blank" rel="noopener">DOI: 10.1111/j.1539-6053.2009.01038.x</a>
        </blockquote>
        <p>该文指出:虽然每个人都有学习偏好,但"按偏好风格教学就能提升学习效果"这一更强主张<strong>缺乏严格的因果证据</strong>。因此:</p>
        <ul>
          <li>本测试结果只描述<strong>你的偏好倾向</strong>,不能推论"必须按某种方式学才有效"</li>
          <li>给出的学习策略是<strong>建议</strong>而非教条;最终判断仍以你自己的实际感受为准</li>
          <li>请不要用本结果给自己或他人贴标签 (如"我是 K 型,听课没用")</li>
        </ul>
      </section>

      <section class="result-section">
        <h3>数据隐私</h3>
        <p>详见 <a href="#/privacy">隐私说明</a>。简言之:本网站不收集任何个人信息,所有测试数据存在你自己的浏览器里。</p>
      </section>

      <p><a href="#/">← 回首页</a></p>
    </div>
  `;
}
